import * as React from 'react';
import { IconProps } from '../types';

const IcFunctionService = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
     <g fill={props?.fill ?? '#232F3E'} clipPath="url(#a)">
      <path d="M6.16 1.989C9.046-.161 13.152-.591 16.482.86c2.996 1.263 5.216 3.978 6.02 7.041.888.081 1.86.619 1.97 1.56.084 1.424.028 2.848.028 4.272.028.78-.61 1.317-1.193 1.72-.416 1.963-1.47 3.79-3.107 5.053-1.804 1.451-4.107 2.204-6.437 2.419-.472 1.156-2.22 1.586-2.997.484-.916-.995.056-2.661 1.387-2.553.75-.054 1.221.564 1.637 1.048 1.998-.242 3.996-.833 5.577-2.043 1.415-1.075 2.442-2.607 2.802-4.327a5.078 5.078 0 0 1-1.303-.833c-.777 2.15-2.359 4.193-4.606 5.053.97-.968 1.914-2.097 2.053-3.467.388-2.876-.389-6.074-2.525-8.197-.222 1.263-.694 2.768-2.109 3.198-1.886.376-3.8.672-5.688 1.075-1.276.296-2.053 1.72-1.664 2.93.277 1.827 1.581 3.251 2.608 4.73-2.275-.86-4.107-2.715-4.967-4.946-.97 1.048-2.996.806-3.357-.618-.194-1.505-.083-3.01-.083-4.515 0-.887.805-1.451 1.554-1.747.582-2.446 1.97-4.73 4.078-6.208Zm3.44.027c-2.607.833-4.744 2.902-5.604 5.429-.166.51-.444 1.075-.166 1.585.832-1.8 2.08-3.467 3.856-4.488 2.858-1.72 6.742-1.64 9.545.188 1.692 1.021 2.774 2.688 3.634 4.38.195-1.45-.665-2.848-1.47-4.03-2.136-2.93-6.298-4.22-9.794-3.064Z" />
      <path d="M15.538 16.61c-.139 1.316-1.498 2.31-2.83 2.31-1.165.054-2.358-.618-2.802-1.666 1.775.914 4.162.726 5.632-.645Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h24v24H.5z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcFunctionService;
